// Toolbar for the Engagements views (speaking/PR boards): view switcher +
// owner filter + stage filter + free-text search. Chrome matches Toolbar.jsx
// but scoped to the smaller filter set engagements need.

import ViewSwitcher from './ViewSwitcher.jsx'
import { useSearchInput } from '../lib/hashRoute.js'

const selectStyle = {
  background: 'var(--color-bg-dark)',
  border: '1px solid var(--color-divider-dark)',
  borderRadius: 'var(--radius-sm)',
  padding: '6px 9px',
  color: 'var(--color-white)',
  fontSize: 12,
}

export default function EngagementToolbar({ view, onSetView, users, ownerFilter, onSetOwnerFilter, stages = [], stage, onSetStage, search, onSetSearch }) {
  const [searchLocal, onSearchChange] = useSearchInput(search, onSetSearch)
  return (
    <div
      className="tb-toolbar"
      style={{
        position: 'relative',
        zIndex: 5,
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '8px 22px',
        minHeight: 52,
        background: 'var(--color-panel-dark)',
        borderBottom: '1px solid var(--color-divider-dark)',
      }}
    >
      <ViewSwitcher
        view={view}
        onSetView={onSetView}
        views={[
          { key: 'list', label: 'List' },
          { key: 'board', label: 'Board' },
          { key: 'calendar', label: 'Calendar' },
          { key: 'table', label: 'Table' },
        ]}
      />

      <div style={{ width: 1, height: 22, background: 'var(--color-divider-dark)' }} />

      <select
        value={ownerFilter || ''}
        onChange={(e) => onSetOwnerFilter(e.target.value || null)}
        style={selectStyle}
      >
        <option value="">All owners</option>
        {users.map((u) => (
          <option key={u.uid} value={u.uid}>{u.name}</option>
        ))}
      </select>

      <select
        value={stage || ''}
        onChange={(e) => onSetStage(e.target.value || null)}
        style={selectStyle}
      >
        <option value="">All stages</option>
        {stages.map((s) => (
          <option key={s.id} value={s.id}>{s.name}</option>
        ))}
      </select>

      <input
        className="cn-input"
        placeholder="Search engagements…"
        value={searchLocal}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{ width: 200 }}
      />
    </div>
  )
}
